(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("LandingPagesModalController", LandingPagesModalController);

    LandingPagesModalController.$inject = ['$scope', 'modalData', '$stateParams', '$sce', '$httpParamSerializer'];
    function LandingPagesModalController($scope, modalData, $stateParams, $sce, $httpParamSerializer) {

        var self = this;
        self.iframe = '';
        self.title = modalData.title;
        self.description = modalData.description;

        var withoutUnderscore = function (value) {
            if(!value) {
                return value;
            }
            return value.split('_').join(' ');
        };

        var createIFrame = function() {

            var utmTrackingData = {
                user_location: modalData.pageVersion,
                utm_campaign: withoutUnderscore($stateParams.utm_campaign),
                utm_content: withoutUnderscore($stateParams.utm_content),
                utm_medium: withoutUnderscore($stateParams.utm_medium),
                utm_source: withoutUnderscore($stateParams.utm_source),
                utm_term: withoutUnderscore($stateParams.utm_term),
                Referrer_link: window.location.pathname,
            };

            var url =  modalData.iframeUrl +  '?' + $httpParamSerializer(utmTrackingData);
            var wrap = document.createElement('div');
            var iframe = document.createElement("iframe");
            iframe.setAttribute("src", url);
            iframe.style.width = modalData.iframeWidth || "100%";
            iframe.style.height = modalData.iframeHeight || "300px";
            iframe.frameBorder = 0;
            iframe.setAttribute('class', 'landing-pages-modal-iframe');
            iframe.onload = function () {
                iFrameResize( { log: false }, '.landing-pages-modal-iframe')
            };

            wrap.appendChild(iframe.cloneNode(true));
            self.iframe = $sce.trustAsHtml(wrap.innerHTML);

        };



        function init() {
            var script = document.createElement('script');
            script.onload = function () {
                createIFrame();
            };
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.1/iframeResizer.min.js';
            document.head.appendChild(script);
        }

        init();

        self.close = function () {
            $scope.$hide();
        };

    }

})();

var getLandingPagesModal = function (modalData) {
    return {
        controller: 'LandingPagesModalController',
        controllerAs: '$ctrl',
        templateUrl: '../scripts/global-directives/landing-pages-modal/landing-pages.modal.html',
        show: true,
        backdrop: 'static',
        resolve: {
            modalData: modalData
        }
    };
};
